// // components/Navbar.jsx
// import React, { useContext, useEffect, useRef, useState } from "react";
// import gsap from "gsap";
// import ScrollTrigger from "gsap/ScrollTrigger";
// import Button from "@mui/material/Button";
// import logo from "../Images/masaar.webp";
// import { ModalContact } from "./ModalContact";
// import { LanguageContext } from "./LanguageContext";

// gsap.registerPlugin(ScrollTrigger);

// const Navbar = () => {
//   const navRef = useRef(null);
//   const tabsRef = useRef([]);
//   const logoRef = useRef(null);
//   const bookNowRef = useRef(null);

//   const toggleRef = useRef(null);
//   const [showModal, setShowModal] = useState(false);
//   const { language, changeLanguage } = useContext(LanguageContext);

//   // معرفات الأقسام ثابتة بالإنجليزية
//   const tabIds = ["about", "amenities", "location", "map"];

//   // النصوص حسب اللغة
//   const tabs = {
//     en: ["About", "Amenities", "Location", "Map"],
//     ar: ["عن المشروع", "الخدمات", "الموقع", "الخريطة"],
//   };

//   const bookNowText = {
//     en: "Book Now",
//     ar: "احجز الآن",
//   };

//   useEffect(() => {
//     const trigger = ScrollTrigger.create({
//       start: "top -10",
//       end: 99999,
//       onUpdate: (self) => {
//         if (!navRef.current) return;
//         if (self.progress > 0) {
//           navRef.current.classList.add("bg-dark", "shadow");
//         } else {
//           navRef.current.classList.remove("bg-dark", "shadow");
//         }
//       },
//     });

//     gsap.fromTo(
//       logoRef.current,
//       { opacity: 0, x: -50 },
//       { opacity: 1, x: 0, duration: 0.8, ease: "power3.out" }
//     );

//     gsap.fromTo(
//       toggleRef.current,
//       { opacity: 0, x: 50 },
//       { opacity: 1, x: 0, duration: 0.8, ease: "power3.out", delay: 0.2 }
//     );

//     gsap.fromTo(
//       tabsRef.current,
//       { opacity: 0, y: 20 },
//       {
//         opacity: 1,
//         y: 0,
//         stagger: 0.1,
//         duration: 0.6,
//         ease: "power3.out",
//         delay: 0.4,
//       }
//     );

//     return () => trigger.kill();
//   }, [language]); // إعادة تفعيل الأنيميشن عند تغيير اللغة


//  useEffect(() => {
//   const pulse = gsap.to(bookNowRef.current, {
//     scale: 1.1,
//     repeat: -1,
//     yoyo: true,
//     ease: "power1.inOut",
//     duration: 0.8,
//   });

//   return () => {
//     pulse.kill(); // تنظيف عند التفكيك أو تغيير اللغة
//   };
// }, [language]); // لو بتحب تعيد تشغيله عند تغيير اللغة


//  const enBtnRef = useRef(null);
//   const arBtnRef = useRef(null);

//   useEffect(() => {
//     if (bookNowRef.current && enBtnRef.current && arBtnRef.current) {
//       const height = bookNowRef.current.offsetHeight;
//       const width = bookNowRef.current.offsetWidth;

//       // نخلي زرارين اللغة نفس ارتفاع وعرض زرار "Book Now"
//       enBtnRef.current.style.height = `${height}px`;
//       enBtnRef.current.style.minWidth = `${width}px`;
//       arBtnRef.current.style.height = `${height}px`;
//       arBtnRef.current.style.minWidth = `${width}px`;
//     }
//   }, []);
//   return (
//     <nav
//       ref={navRef}
//       className="navbar navbar-expand-lg fixed-top navbar-dark transition-all"
//       dir={language === "ar" ? "rtl" : "ltr"} // تحديد اتجاه الصفحة حسب اللغة
//     >
//       <div className="container">
//         {/* Logo */}
//         <a
//           className="navbar-brand fw-bold fs-4"
//           href="#"
//           ref={logoRef}
//           alt="Masaar Logo"
//         >
//           <img src={logo} alt="Masaar Logo" />
//         </a>

//         {/* Mobile toggle */}
//         <button
//           ref={toggleRef}
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarNav"
//           aria-controls="navbarNav"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <span className="navbar-toggler-icon"></span>
//         </button>

//         {/* Nav Links */}
//         <div className="collapse navbar-collapse" id="navbarNav">
//           <ul
//             className={`navbar-nav ${
//               language === "ar" ? "me-auto" : "ms-auto"
//             } mb-2 mb-lg-0 align-items-center`}
//           >
//             {tabIds.map((id, index) => (
//               <li
//                 className="nav-item"
//                 key={id}
//                 ref={(el) => (tabsRef.current[index] = el)}
//                 style={{ transition: "all 0.3s ease" }}
//               >
//                 <a
//                   className="nav-link"
//                   href={`#${id}`} // معرف id ثابت بالإنجليزي
//                   onMouseEnter={(e) => {
//                     gsap.to(e.currentTarget, {
//                       scale: 1.1,
//                       color: "#ffcc00",
//                       duration: 0.3,
//                     });
//                   }}
//                   onMouseLeave={(e) => {
//                     gsap.to(e.currentTarget, {
//                       scale: 1,
//                       color: "",
//                       duration: 0.3,
//                     });
//                   }}
//                 >
//                   {tabs[language][index]} {/* النص حسب اللغة */}
//                 </a>
//               </li>
//             ))}

//  <li className="nav-item ms-lg-3">
//         <Button
//           ref={bookNowRef}
//           className="book-now-btn"
//           variant="contained"
//           color="warning"
//           size="small"
//           onClick={(e) => {
//             e.preventDefault();
//             setShowModal(true);
//           }}
//         >
//           {language === "en" ? "Book Now" : "احجز الآن"}
//         </Button>
//         {/* افترضت عندك ModalContact */}
//         <ModalContact open={showModal} onClose={() => setShowModal(false)} />
//       </li>

//             {/* Book Now Button */}
//            <li className="nav-item d-flex align-items-center ms-3 my-2 gap-2">
//         <button
//           ref={enBtnRef}
//           onClick={() => changeLanguage("en")}
//           className={`btn btn-sm btn-outline-light ${
//             language === "en" ? "active" : ""
//           }`}
//         >
//           EN
//         </button>
//         <button
//           ref={arBtnRef}
//           onClick={() => changeLanguage("ar")}
//           className={`btn btn-sm btn-outline-light ${
//             language === "ar" ? "active" : ""
//           }`}
//         >
//           AR
//         </button>
//       </li>
//           </ul>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;






























// components/Navbar.jsx
import React, { useContext, useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Button from "@mui/material/Button";
import logo from "../Images/masaar.webp";
import { ModalContact } from "./ModalContact";
import { LanguageContext } from "./LanguageContext";

gsap.registerPlugin(ScrollTrigger);

// ========== Floating 3D Leaf ==========
const FloatingLeaf = () => {
  const leafRef = useRef(null);
  useEffect(() => {
    gsap.to(leafRef.current, {
      x: 10, y: 5, rotation: 15, scaleX: 0.65,
      duration: 2.4, ease: "sine.inOut", yoyo: true, repeat: -1,
    });
    gsap.to(leafRef.current, {
      scaleY: 0.85, duration: 1.8, ease: "sine.inOut",
      yoyo: true, repeat: -1, delay: 0.5,
    });
  }, []);
  return (
    <span ref={leafRef} style={{
      display: "inline-block", fontSize: "1.1rem",
      transformOrigin: "center center",
      filter: "drop-shadow(0 2px 4px rgba(74,124,63,0.6))",
    }}>🍃</span>
  );
};

// ========== Navbar ==========
const Navbar = () => {
  const logoRef    = useRef(null);
  const toggleRef  = useRef(null);
  const bookNowRef = useRef(null);
  const drawerRef  = useRef(null);
  const overlayRef = useRef(null);
  const drawerItemsRef = useRef([]);

  const [showModal, setShowModal] = useState(false);
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);

  const { language, changeLanguage } = useContext(LanguageContext);
  const isRTL = language === "ar";

  const tabIds = ["about", "amenities", "location", "map"];
  const texts = {
    en: { tabs: ["About", "Amenities", "Location", "Map"], bookNow: "Book Now",  title: "Menu" },
    ar: { tabs: ["عن المشروع", "الخدمات", "الموقع", "الخريطة"], bookNow: "احجز الآن", title: "القائمة" },
  };

  // ─── Scroll ───────────────────────────────────────────────────
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ─── Navbar Entry Animation ───────────────────────────────────
  useEffect(() => {
    gsap.killTweensOf([logoRef.current, toggleRef.current, bookNowRef.current]);
    gsap.set(logoRef.current,    { opacity: 0, x: isRTL ? 30 : -30 });
    gsap.set(toggleRef.current,  { opacity: 0, x: isRTL ? -30 : 30 });
    gsap.set(bookNowRef.current, { opacity: 0, scale: 0.8 });

    const tl = gsap.timeline({ delay: 0.2 });
    tl.to(logoRef.current,    { opacity: 1, x: 0, duration: 0.7, ease: "power3.out" })
      .to(bookNowRef.current, { opacity: 1, scale: 1, duration: 0.5, ease: "back.out(1.7)" }, "-=0.3")
      .to(toggleRef.current,  { opacity: 1, x: 0, duration: 0.5, ease: "power3.out" }, "-=0.3");
  }, [language]);

  // ─── Book Now Pulse ───────────────────────────────────────────
  useEffect(() => {
    const pulse = gsap.to(bookNowRef.current, {
      scale: 1.07, repeat: -1, yoyo: true,
      ease: "sine.inOut", duration: 1, delay: 2,
    });
    return () => pulse.kill();
  }, [language]);

  // ─── Drawer Open/Close Animation ─────────────────────────────
  useEffect(() => {
    const drawer  = drawerRef.current;
    const overlay = overlayRef.current;
    const items   = drawerItemsRef.current;

    if (menuOpen) {
      // منع scroll الصفحة
      document.body.style.overflow = "hidden";

      // Overlay fade in
      gsap.to(overlay, { opacity: 1, pointerEvents: "auto", duration: 0.3, ease: "power2.out" });

      // Drawer slide in
      gsap.fromTo(drawer,
        { x: isRTL ? "100%" : "-100%", opacity: 0.5 },
        { x: "0%", opacity: 1, duration: 0.45, ease: "power3.out" }
      );

      // Items stagger
      gsap.fromTo(items,
        { opacity: 0, x: isRTL ? 30 : -30 },
        { opacity: 1, x: 0, stagger: 0.07, duration: 0.4,
          ease: "power3.out", delay: 0.2 }
      );
    } else {
      document.body.style.overflow = "";

      gsap.to(overlay, { opacity: 0, pointerEvents: "none", duration: 0.3 });
      gsap.to(drawer,  { x: isRTL ? "100%" : "-100%", opacity: 0.5,
        duration: 0.35, ease: "power3.in" });
    }
  }, [menuOpen, isRTL]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      {/* ══════════════════════════════════════════════
          NAVBAR BAR
      ══════════════════════════════════════════════ */}
      <nav
        dir={isRTL ? "rtl" : "ltr"}
        className="fixed-top"
        style={{
          fontFamily:      "'Cairo', sans-serif",
          zIndex:          1000,
          transition:      "background 0.4s ease, box-shadow 0.4s ease",
          backgroundColor: scrolled ? "rgba(8,18,8,0.96)" : "transparent",
          boxShadow:       scrolled ? "0 2px 24px rgba(0,0,0,0.5)" : "none",
          backdropFilter:  scrolled ? "blur(16px)" : "none",
          borderBottom:    scrolled ? "1px solid rgba(74,124,63,0.2)" : "1px solid transparent",
          padding:         "0.6rem 0",
        }}
      >
        <div className="container d-flex align-items-center justify-content-between">

          {/* Logo */}
          <a href="#" ref={logoRef} style={{ opacity: 0, textDecoration: "none",
            display: "flex", alignItems: "center", gap: "10px" }}>
            <img src={logo} alt="Masaar Logo"
              style={{ height: "clamp(34px, 4.5vw, 44px)", width: "auto" }} />
            <FloatingLeaf />
          </a>

          {/* Right side: Book Now + Hamburger */}
          <div style={{ display: "flex", alignItems: "center",
            gap: "12px", flexDirection: isRTL ? "row-reverse" : "row" }}>

            {/* Book Now — ظاهر دايماً */}
            <Button
              ref={bookNowRef}
              variant="contained"
              size="small"
              onClick={() => setShowModal(true)}
              sx={{
                fontFamily:  "'Cairo', sans-serif",
                fontWeight:  700,
                fontSize:    "clamp(0.78rem, 1.4vw, 0.88rem)",
                px:          { xs: 2, md: 3 },
                py:          { xs: 0.7, md: 0.9 },
                borderRadius:"50px",
                opacity:     0,
                letterSpacing: "0.03em",
                background:  "linear-gradient(135deg, #3d6b35 0%, #6aad55 100%)",
                boxShadow:   "0 4px 16px rgba(74,124,63,0.4)",
                "&:hover": {
                  background: "linear-gradient(135deg, #2f5228 0%, #5a9e4a 100%)",
                  boxShadow:  "0 6px 22px rgba(74,124,63,0.55)",
                },
              }}
            >
              <span style={{ marginInlineEnd: "5px", fontSize: "0.82rem" }}>🌿</span>
              {texts[language].bookNow}
            </Button>
            <ModalContact open={showModal} onClose={() => setShowModal(false)} />

            {/* Hamburger */}
            <button
              ref={toggleRef}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
              style={{
                opacity:      0,
                background:   "rgba(74,124,63,0.18)",
                border:       "1px solid rgba(74,124,63,0.35)",
                borderRadius: "10px",
                padding:      "8px 10px",
                cursor:       "pointer",
                display:      "flex",
                flexDirection:"column",
                gap:          "5px",
                transition:   "background 0.2s ease",
              }}
            >
              {[22, 14, 22].map((w, i) => (
                <span key={i} style={{
                  display:     "block",
                  width:       `${w}px`,
                  height:      "2px",
                  background:  menuOpen ? "#6aad55" : "rgba(255,255,255,0.85)",
                  borderRadius:"2px",
                  transition:  "all 0.3s ease",
                  transform:   menuOpen && i === 0 ? "rotate(45deg) translate(5px,5px)"
                             : menuOpen && i === 2 ? "rotate(-45deg) translate(5px,-5px)"
                             : menuOpen && i === 1 ? "scaleX(0)" : "none",
                  marginInlineStart: i === 1 ? "4px" : "0",
                }} />
              ))}
            </button>
          </div>
        </div>
      </nav>

      {/* ══════════════════════════════════════════════
          OVERLAY
      ══════════════════════════════════════════════ */}
      <div
        ref={overlayRef}
        onClick={closeMenu}
        style={{
          position:       "fixed",
          inset:          0,
          background:     "rgba(0,0,0,0.6)",
          backdropFilter: "blur(3px)",
          zIndex:         1100,
          opacity:        0,
          pointerEvents:  "none",
          transition:     "none",
        }}
      />

      {/* ══════════════════════════════════════════════
          DRAWER
      ══════════════════════════════════════════════ */}
      <div
        ref={drawerRef}
        dir={isRTL ? "rtl" : "ltr"}
        style={{
          position:        "fixed",
          top:             0,
          [isRTL ? "right" : "left"]: 0,
          width:           "min(300px, 82vw)",
          height:          "100dvh",
          background:      "linear-gradient(160deg, #0a180a 0%, #0f220f 60%, #081408 100%)",
          borderInlineEnd: isRTL ? "none" : "1px solid rgba(74,124,63,0.25)",
          borderInlineStart: isRTL ? "1px solid rgba(74,124,63,0.25)" : "none",
          zIndex:          1200,
          transform:       isRTL ? "translateX(100%)" : "translateX(-100%)",
          display:         "flex",
          flexDirection:   "column",
          padding:         "0",
          overflowY:       "auto",
          boxShadow:       isRTL
                             ? "-8px 0 40px rgba(0,0,0,0.6)"
                             : "8px 0 40px rgba(0,0,0,0.6)",
        }}
      >
        {/* Drawer Header */}
        <div
          ref={(el) => (drawerItemsRef.current[0] = el)}
          style={{
            display:        "flex",
            alignItems:     "center",
            justifyContent: "space-between",
            padding:        "20px 24px 16px",
            borderBottom:   "1px solid rgba(74,124,63,0.2)",
            flexDirection:  isRTL ? "row-reverse" : "row",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px",
            flexDirection: isRTL ? "row-reverse" : "row" }}>
            <span style={{ fontSize: "1.3rem" }}>🌿</span>
            <span style={{
              fontFamily: "'Cairo', sans-serif",
              fontWeight: 700,
              fontSize:   "1rem",
              color:      "#6aad55",
              letterSpacing: "0.05em",
            }}>
              {texts[language].title}
            </span>
          </div>
          {/* Close Button */}
          <button
            onClick={closeMenu}
            style={{
              background:   "rgba(74,124,63,0.15)",
              border:       "1px solid rgba(74,124,63,0.3)",
              borderRadius: "8px",
              color:        "rgba(255,255,255,0.7)",
              width:        "34px",
              height:       "34px",
              cursor:       "pointer",
              fontSize:     "1.1rem",
              display:      "flex",
              alignItems:   "center",
              justifyContent:"center",
              transition:   "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(74,124,63,0.3)";
              e.currentTarget.style.color      = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(74,124,63,0.15)";
              e.currentTarget.style.color      = "rgba(255,255,255,0.7)";
            }}
          >✕</button>
        </div>

        {/* Nav Links */}
        <nav style={{ padding: "16px 16px", flex: 1 }}>
          {tabIds.map((id, index) => (
            
              // key={id}
             <a key={id} href={`#${id}`}
              ref={(el) => (drawerItemsRef.current[index + 1] = el)}
              onClick={closeMenu}
              style={{
                display:        "flex",
                alignItems:     "center",
                gap:            "12px",
                flexDirection:  isRTL ? "row-reverse" : "row",
                padding:        "14px 16px",
                marginBottom:   "4px",
                borderRadius:   "12px",
                textDecoration: "none",
                color:          "rgba(255,255,255,0.82)",
                fontFamily:     "'Cairo', sans-serif",
                fontWeight:     600,
                fontSize:       "1rem",
                border:         "1px solid transparent",
                transition:     "all 0.22s ease",
                background:     "transparent",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background   = "rgba(74,124,63,0.15)";
                e.currentTarget.style.borderColor  = "rgba(74,124,63,0.3)";
                e.currentTarget.style.color        = "#6aad55";
                e.currentTarget.style.paddingInlineStart = isRTL ? "16px" : "22px";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background   = "transparent";
                e.currentTarget.style.borderColor  = "transparent";
                e.currentTarget.style.color        = "rgba(255,255,255,0.82)";
                e.currentTarget.style.paddingInlineStart = "16px";
              }}
            >
              {/* رقم اللينك */}
              <span style={{
                fontFamily:  "'Cairo', sans-serif",
                fontSize:    "0.7rem",
                fontWeight:  700,
                color:       "#4a7c3f",
                minWidth:    "20px",
                textAlign:   "center",
                letterSpacing: "0.05em",
              }}>
                0{index + 1}
              </span>
              {/* خط فاصل */}
              <span style={{ width: "1px", height: "16px",
                background: "rgba(74,124,63,0.4)" }} />
              {texts[language].tabs[index]}
            </a>
          ))}
        </nav>

        {/* Drawer Footer */}
        <div
          ref={(el) => (drawerItemsRef.current[tabIds.length + 1] = el)}
          style={{
            padding:     "20px 24px",
            borderTop:   "1px solid rgba(74,124,63,0.2)",
            display:     "flex",
            flexDirection:"column",
            gap:         "12px",
          }}
        >
          {/* Language Switcher */}
          <div style={{ display: "flex", gap: "8px",
            flexDirection: isRTL ? "row-reverse" : "row" }}>
            <span style={{ fontFamily: "'Cairo', sans-serif", fontSize: "0.78rem",
              color: "rgba(255,255,255,0.4)", alignSelf: "center" }}>
              {isRTL ? "اللغة:" : "Language:"}
            </span>
            {["en", "ar"].map((lang) => (
              <button
                key={lang}
                onClick={() => changeLanguage(lang)}
                style={{
                  fontFamily:   "'Cairo', sans-serif",
                  fontWeight:   700,
                  fontSize:     "0.78rem",
                  letterSpacing:"0.06em",
                  borderRadius: "8px",
                  padding:      "5px 14px",
                  border:       language === lang
                                  ? "1px solid rgba(106,173,85,0.7)"
                                  : "1px solid rgba(255,255,255,0.15)",
                  color:        language === lang ? "#6aad55" : "rgba(255,255,255,0.45)",
                  background:   language === lang ? "rgba(74,124,63,0.2)" : "transparent",
                  cursor:       "pointer",
                  transition:   "all 0.2s ease",
                }}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </div>

          {/* Book Now داخل الـ drawer */}
          <Button
            variant="contained"
            fullWidth
            onClick={() => { setShowModal(true); closeMenu(); }}
            sx={{
              fontFamily:   "'Cairo', sans-serif",
              fontWeight:   700,
              fontSize:     "0.95rem",
              py:           1.3,
              borderRadius: "12px",
              letterSpacing:"0.04em",
              background:   "linear-gradient(135deg, #3d6b35 0%, #6aad55 100%)",
              boxShadow:    "0 4px 20px rgba(74,124,63,0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #2f5228 0%, #5a9e4a 100%)",
                boxShadow:  "0 6px 28px rgba(74,124,63,0.55)",
              },
            }}
          >
            <span style={{ marginInlineEnd: "8px" }}>🌿</span>
            {texts[language].bookNow}
          </Button>

          {/* Branding */}
          <p style={{
            fontFamily:  "'Cairo', sans-serif",
            fontSize:    "0.72rem",
            color:       "rgba(255,255,255,0.2)",
            textAlign:   "center",
            margin:      0,
            letterSpacing:"0.05em",
          }}>
            © 2024 Masaar Real Estate
          </p>
        </div>
      </div>
    </>
  );
};

export default Navbar;